// extracted by mini-css-extract-plugin
export default {"icon":"src-components-Modules-Components-ResponsiveRichEdit-css-module__icon--dolv+"};